"use client";
import React, { createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/apiconfig";

const BulkSMSContext = createContext();


export const BulkSMSProvider = ({ children }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);

  const getToken = () => localStorage.getItem("token");

  const headers = () => {
    const token = getToken();
    return {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  };

  // ✅ Get All (Dynamic)
  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/bulk-sms`, {
        headers: headers(),
      });

      const json = await res.json();

      if (json?.status === "200" && Array.isArray(json.data)) {
     const mapped = json.data.map((c) => ({
  id: c.id,
  name: c.name,
  message: c.message,

  // ✅ map status correctly
  status:"Active",
  scheduledAt: c.schedule_at,
  sentAt: c.schedule_type,
  createdAt: c.create_audit_time,

  contactLists: c.contact ? JSON.parse(c.contact) : [],
  recipients: 0,

  template: c.campaign_type?.toLowerCase(),
}));
        setCampaigns(mapped);
      } else {
        setCampaigns([]);
      }
    } catch (error) {
      console.error("Fetch campaigns failed", error);
      setCampaigns([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Create
  const createCampaign = async (data) => {
    const res = await fetch(`${BASE_URL}/bulk-sms`, {
      method: "POST",
      headers: headers(),
      body: JSON.stringify(data),
    });

    const json = await res.json();
    if (json?.status === "201") {
      await fetchCampaigns(); // 🔁 auto refresh
    }

    return json;
  };

  // ✅ Update
  const updateCampaign = async (id, data) => {
    const res = await fetch(`${BASE_URL}/bulk-sms/${id}`, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify(data),
    });

    const json = await res.json();

    if (json?.status === "200") {
      await fetchCampaigns(); // 🔁 auto refresh
    }

    return json;
  };

  // ✅ Delete
  const deleteCampaign = async (id, delete_audit_id) => {
    const res = await fetch(`${BASE_URL}/bulk-sms/${id}`, {
      method: "DELETE",
      headers: headers(),
      body: JSON.stringify({ delete_audit_id }),
    });

    const json = await res.json();

    if (json?.status === "200") {
      await fetchCampaigns(); // 🔁 auto refresh
    }

    return json;
  };

  // ✅ Auto load on page open
  useEffect(() => {
    fetchCampaigns();
  }, []);

  return (
    <BulkSMSContext.Provider
      value={{
        campaigns,
        loading,
        setCampaigns,   // ← add this
        fetchCampaigns,
        createCampaign,
        updateCampaign,
        deleteCampaign,
      }}
    >
      {children}
    </BulkSMSContext.Provider>
  );
};

export const useBulkSMS = () => useContext(BulkSMSContext);
